export default {"src":"/_next/static/media/code.06abcfd7.svg","height":24,"width":22};